import React, { useMemo, useState } from "react";
import { message, Modal } from "antd";
import smartLendLogo from "./img/sl_long_new_logo_wo_beta.png";
import singpassLogo from "./img/singpass_logo.png";
import corppasslogo from "./img/corppass_logo.png";
import googleLogo from "./img/googlelogo.webp";
import bankImage from "./img/11.png";
import bankImage1 from "./img/12.png";
import bankImage2 from "./img/13.png";
import bankImage3 from "./img/14.png";
import bankImage4 from "./img/15.png";
import bankImage5 from "./img/16.png";
import bankImage6 from "./img/17.png";
import bankImage7 from "./img/18.png";
import bankImage8 from "./img/19.png";
import "./NewHomepage.css";
import asianWomanHappy from "../src/img/asian2.png";
import smlblacktmen from "../../../../src/assets/img/guy_black_T_homepage.png";
import { useMediaQuery } from "@mui/material";
import { useHistory } from "react-router-dom";
import HomeHeader from "./Headesr";
import NewHomepageFooter from "./NewHomepageFooter";
import { Slider } from "@mui/material";

const faqs = [
  {
    cat: "general",
    q: "How do I apply for a Business Loan?",
    a: "Click sign up, complete your SmartLend account, then apply from your dashboard.",
  },
  {
    cat: "general",
    q: "Can anyone apply for a Business Loan?",
    a: "Locally incorporated LLP and Pte. Ltd. entities can apply. If your entity is different, contact support@smart-lend.com.",
  },
  {
    cat: "general",
    q: "Why can’t I apply for a loan?",
    a: "You may need to sync your CorpPass account with Singpass before applying.",
  },
  {
    cat: "general",
    q: "How long does it take for me to get a loan approved?",
    a: "Typical offer turnaround is 1 to 5 working days depending on profile and documentation.",
  },
  {
    cat: "rates",
    q: "Why do all the offers have the same interest rate and processing fee?",
    a: (
      <>
        <p>
          We standardize the interest rate and processing fee across every
          lender so you can compare offers fairly. Instead of competing on
          price, our lenders compete on what actually helps you — how quickly
          they fund, how much they&apos;ll lend, tenor flexibility, and service.
        </p>
        <p>
          Every rate also sits within the limits set by the Ministry of Law, so
          you&apos;re always protected.
        </p>
      </>
    ),
  },
  {
    cat: "rates",
    q: "I've seen lower rates advertised elsewhere. Why not on SmartLend?",
    a: (
      <>
        <p>
          Some lenders advertise a very low rate to attract borrowers, then
          adjust it upward once you visit the branch and they review your
          documents. We don&apos;t allow that &quot;bait-and-switch&quot; here.
        </p>
        <p>
          On SmartLend, the rate shown is the rate the lender commits to honour
          — no surprise increases after you&apos;ve already chosen them. A
          headline rate advertised elsewhere often isn&apos;t the rate you
          actually get once fees and post-assessment changes are added in.
        </p>
      </>
    ),
  },
  {
    cat: "rates",
    q: "Can the rate still change after I pick a lender?",
    a: (
      <>
        <p>
          The rate you see is the committed ceiling — a lender can never start
          higher than it. After you visit the branch and they complete their due
          diligence, there may be room to negotiate the rate down further.
        </p>
        <p>In other words, it only ever moves in your favour.</p>
      </>
    ),
  },
  {
    cat: "rates",
    q: "If every lender charges the same, how do I choose one?",
    a: (
      <p>
        Focus on what actually differs between offers: how fast the lender can
        disburse funds, the loan amount they&apos;re offering, tenor
        flexibility, the documents they require, and their reputation and
        service. These are the things that genuinely affect your borrowing
        experience — not a headline number.
      </p>
    ),
  },
  {
    cat: "rates",
    q: "Are these rates within legal limits?",
    a: (
      <p>
        Yes. All interest rates and fees on SmartLend follow the caps set by the
        Ministry of Law — a maximum of 4% monthly interest and a processing fee
        of up to 10% of the principal. You&apos;ll never be quoted above the
        legal limit on our platform.
      </p>
    ),
  },
];

const faqCategories = [
  { key: "all", label: "All" },
  { key: "general", label: "General" },
  { key: "rates", label: "Rates" },
];

const reviews = [
  {
    name: "Md. Abdullah Al Mahmud",
    text: "Exceptional service from start to finish — smooth, clear and highly professional.",
  },
  {
    name: "Barbara Ng",
    text: "Professional and efficient support with practical recommendations tailored to my needs.",
  },
  {
    name: "Tan Boon Thye",
    text: "Very helpful team and great guidance for business financing.",
  },
];

const featuredLogos = [
  bankImage,
  bankImage1,
  bankImage2,
  bankImage3,
  bankImage4,
  bankImage5,
  bankImage6,
  bankImage7,
  bankImage8,
];

const quickStats = [
  { big: "20+", label: "Alternative lenders and more currently on-board" },
  { big: "2000+", label: "SME’s Success Stories" },
  { big: "5★", label: "Google Review" },
  { big: "📄", label: "Complimentary CBS Report & Free Home Valuation" },
];

const conciergeBenefits = [
  {
    title: "Dedicated RM, Unified Inbox",
    desc: "We liaise with lenders so you can focus on your business and avoid approval stress.",
    icon: "👤",
  },
  {
    title: "Pre-Qualified Loan Matches",
    desc: "Say goodbye to generic rejections. We connect you only with lenders you're eligible for.",
    icon: "✅",
  },
  {
    title: "Priority Processing & Faster Turnarounds",
    desc: "Jump the queue—your application gets flagged for faster review and disbursal.",
    icon: "⚡",
  },
  {
    title: "Smart Monitoring & Early Refinance Alerts",
    desc: "Get notified when you're eligible for better terms. We track your loan health for opportunities.",
    icon: "🔔",
  },
];

const clientTestimonials = [
  {
    name: "Adam Chang",
    role: "Wholesale of Beverage Owner",
    stars: 5,
    text: "Super easy to apply — I just scanned my Singpass and was done in under 3 minutes! Way better than other sites where I had to key in all my personal and company info manually. Best part? I got multiple offers to compare within a day.",
  },
  {
    name: "Fatimah",
    role: "Wedding Planner Owner",
    stars: 5,
    text: "I needed short-term funding for my seasonal business and decided to try SmartLend instead of going through a loan broker. Got the funding I needed in just 5 days — and best of all, no hefty third-party fees.",
  },
  {
    name: "Alfred Ong",
    role: "Construction Firm Owner",
    stars: 5,
    text: "I was skeptical about concierge at first, but I’m happy they delivered what they promised. There were some hiccups, but the SmartLend team pushed hard to get me the tenor I needed.",
  },
  {
    name: "Raj Kumar",
    role: "F&B Business Owner",
    stars: 5,
    text: "Got rejected by the banks, but SmartLend helped me secure a small loan to tide over until invoices came in. Really thankful they made it happen when we needed it most.",
  },
  {
    name: "Sri Laksmi",
    role: "Retail of Dried & Fresh Flowers Owner",
    stars: 5,
    text: "SmartLend made the whole process super easy and fast — I applied in minutes, compared offers, and tracked everything in one place. It really puts the power back in the borrower’s hands!",
  },
  {
    name: "Hong Wang Goh",
    role: "General",
    stars: 5,
    text: "Victoria is very helpful and patient. She put in a lot of effort to help source funding for my business. Highly recommend for business owners to approach her for funding needs.",
  },
];

const NewHomepage = () => {
  const [openFaq, setOpenFaq] = useState(0);
  const [faqCat, setFaqCat] = useState("all");
  const [emailSubscription, setEmailSubscription] = useState("");
  const [conciergeModalIsOpen, setConciergeModalIsOpen] = useState(false);
  const [amountForCalculation, setAmountForCalculation] = useState(1000);
  const history = useHistory();

  const isMobile = useMediaQuery("(max-width:600px)");
  const filteredFaqs = useMemo(() => {
    if (faqCat === "all") return faqs;
    return faqs.filter((item) => item.cat === faqCat);
  }, [faqCat]);

  const calculateConciergeFee = () => {
    let amount = 0;
    if (amountForCalculation < 20000) {
      amount = (amountForCalculation * 0.01).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else if (amountForCalculation < 49999) {
      amount = (amountForCalculation * 0.015).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } else {
      amount = (amountForCalculation * 0.02).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
    return amount;
  };
  const navigateTo = (path) => {
    history.push(path);
    window.scrollTo(0, 0);
  };

  const handleEmailSubscription = async (event) => {
    event.preventDefault();

    if (!emailSubscription) {
      message.error("Please enter your email address.");
      return;
    }

    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/guest/subscribeEmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: emailSubscription }),
        },
      );

      if (
        response.ok &&
        response.headers.get("content-type")?.includes("application/json")
      ) {
        const data = await response.json();
        message.success(data.message || "Subscribed successfully!");
        setEmailSubscription("");
      } else {
        message.error("Your email is already subscribed.");
      }
    } catch (error) {
      message.error("Failed to subscribe. Please try again.");
    }
  };
  // Duplicate logos for seamless marquee loop
  const marqueeLogos = useMemo(
    () => [...featuredLogos, ...featuredLogos, ...featuredLogos],
    [],
  );

  return (
    <div className="nh-page" id="top">
      <Modal
        style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
        open={conciergeModalIsOpen}
        width={window.innerWidth < 1200 ? "90vw" : "70vw"}
        onCancel={() => setConciergeModalIsOpen(false)}
        footer={null}
      >
        <div
          style={{
            width: "calc(100% - 40px)",
            padding: "10px",
            display: "flex",
            color: "rgba(0,0,0,0.7)",
            alignItems: "center",
            flexDirection: window.innerWidth < 1200 ? "column" : "row",
          }}
        >
          <div style={{ width: window.innerWidth < 1200 ? "100%" : "60%" }}>
            <div
              style={{
                fontSize: "30px",
                fontWeight: 700,
                color: "rgb(45, 128, 195)",
              }}
            >
              <div
                style={{
                  color: "#f5b400",
                  fontSize: "40px",
                  lineHeight: "40px",
                }}
              >
                Concierge Service
              </div>{" "}
              <div
                style={{
                  color: "rgba(12, 36, 88, 0.98)",
                  marginTop: "0px",
                  lineHeight: "30px",
                }}
              >
                Success-Based Fee Structure
              </div>
            </div>
            <div style={{ width: "90%", fontSize: "12px" }}>
              <div
                style={{
                  display: "flex",
                  borderTop: "1px solid grey",
                  borderLeft: "1px solid grey",
                  borderRight: "1px solid grey",
                  padding: "5px",
                  marginTop: "20px",
                  fontWeight: 700,
                }}
              >
                <div style={{ width: "70%" }}>
                  Approved & Disbursed Loan Amount
                </div>
                <div style={{ width: "30%" }}>Concierge Service Fee</div>
              </div>
              <div
                style={{
                  display: "flex",
                  borderTop: "1px solid grey",
                  borderLeft: "1px solid grey",
                  borderRight: "1px solid grey",
                  padding: "5px",
                }}
              >
                <div style={{ width: "70%" }}>Below S$ 20,000</div>
                <div style={{ width: "30%" }}>1.0 %</div>
              </div>
              <div
                style={{
                  display: "flex",
                  borderTop: "1px solid grey",
                  borderLeft: "1px solid grey",
                  borderRight: "1px solid grey",
                  padding: "5px",
                }}
              >
                <div style={{ width: "70%" }}>S$ 20,000 to S$ 49,999</div>
                <div style={{ width: "30%" }}>1.5 %</div>
              </div>
              <div
                style={{
                  display: "flex",
                  border: "1px solid grey",
                  padding: "5px",
                }}
              >
                <div style={{ width: "70%" }}>S$ 50,000 and above</div>
                <div style={{ width: "30%" }}>2.0 %</div>
              </div>
            </div>
            <div
              style={{ fontSize: "10px", fontWeight: 400, marginTop: "15px" }}
            >
              <span style={{ fontWeight: 700 }}>Disclaimer:</span> Fees are
              success-based and only applicable upon full disbursement of the
              approved loan amount. No fees will be charged if the borrower does
              not proceed with the signing or disbursement.
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: window.innerWidth < 1200 ? "row" : "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "20px",
              marginTop: window.innerWidth < 1200 ? "20px" : "0px",
              marginBottom: window.innerWidth < 1200 ? "20px" : "0px",
            }}
          >
            <div
              style={{
                height: window.innerWidth < 1200 ? "1px" : "100px",
                background: "lightgrey",
                width: window.innerWidth < 1200 ? "20vw" : "1px",
              }}
            />
            <div style={{ color: "lightgrey", fontSize: "12px" }}>Simulate</div>
            <div
              style={{
                height: window.innerWidth < 1200 ? "1px" : "100px",
                background: "lightgrey",
                width: window.innerWidth < 1200 ? "20vw" : "1px",
              }}
            />
          </div>
          <div
            style={{
              marginLeft: "20px",
              width: window.innerWidth < 1200 ? "100%" : "35%",
            }}
          >
            <div
              style={{
                fontSize: "25px",
                fontWeight: 700,
                color: "rgba(12, 36, 88, 0.98)",
              }}
            >
              Calculate Concierge Fees
            </div>
            <div style={{ marginTop: "15px", color: "grey" }}>Loan Amount</div>
            <div style={{ display: "flex", gap: "20px" }}>
              <div style={{ width: "65%", marginLeft: "8px" }}>
                <Slider
                  value={amountForCalculation}
                  onChange={(e, newValue) => setAmountForCalculation(newValue)}
                  min={1000}
                  max={200000}
                  step={1000}
                  width={"80%"}
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "10px",
                    fontWeight: 400,
                    color: "grey",
                  }}
                >
                  <div>S$ 1,000</div>
                  <div>S$ 200,000</div>
                </div>
              </div>
              <div
                style={{
                  width: "30%",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px",
                }}
              >
                S$
                <input
                  value={amountForCalculation}
                  style={{
                    width: "80%",
                    border: "1px solid lightgrey",
                    outline: "none",
                    padding: "4px 8px",
                    borderRadius: "6px",
                  }}
                  onChange={(e) => {
                    setAmountForCalculation(e.target.value);
                  }}
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                width: "100%",
                marginTop: "15px",
              }}
            >
              <div
                style={{
                  margin: "0px",
                  color: "grey",
                }}
              >
                Success-based Concierge Fees
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  margin: "0px",
                }}
              >
                <div style={{ marginTop: "6px", marginRight: "7px" }}> S$</div>
                <span
                  style={{
                    color: "#7a5cff",
                    fontSize: "30px",
                    fontWeight: 700,
                    margin: "0px 0px 0px 0px",
                  }}
                >
                  {calculateConciergeFee()}
                </span>
              </div>
            </div>
            <div style={{ display: "flex", marginTop: "15px" }}>
              <div
                className="nh-btn primary"
                onClick={() => {
                  history.push("/auth/signin");
                  window.scrollTo(0, 0);
                }}
              >
                Apply Now
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {/* background layers */}
      <div className="nh-bg" aria-hidden="true">
        <span className="nh-glow a" />
        <span className="nh-glow b" />
        <span className="nh-glow c" />
      </div>

      <HomeHeader variant="new-homepage" />

      <main className="nh-main">
        {/* HERO (Image left, content right) */}
        <section className="nh-hero nh-heroSplit">
          <div className="nh-wrap">
            <div className="nh-heroSplitCard">
              {/* LEFT: BIG IMAGE */}
              <div className="nh-heroSplitMedia" aria-hidden="true">
                <img className="nh-heroSplitImg" src={smlblacktmen} alt="" />
                {/* <div className="nh-heroSplitGlow" />
                <div className="nh-heroSplitFade" /> */}
              </div>

              {/* RIGHT: CONTENT */}
              <div className="nh-heroSplitContent">
                <div className="nh-pill">
                  <span className="nh-pillDot" />
                  <span>Business &amp; Personal Financing</span>
                  <span className="nh-pillSep" />
                  <span>Singapore</span>
                </div>

                <h1 className="nh-h1">
                  Fast funding, transparent terms —{" "}
                  <span className="nh-grad">built for modern borrowers.</span>
                </h1>

                <p className="nh-lead">
                  Compare lender options, onboard with Singpass/CorpPass, and
                  move from application to offer with confidence — without messy
                  paperwork.
                </p>

                <div className="nh-heroActions">
                  <button
                    className="nh-btn primary lg"
                    type="button"
                    onClick={() => navigateTo("/auth/signin")}
                  >
                    Start application <span className="nh-arrow">→</span>
                  </button>
                  <button
                    className="nh-btn soft lg"
                    type="button"
                    onClick={() => navigateTo("/contactus")}
                  >
                    Talk to an advisor
                  </button>
                </div>

                <div className="nh-statRow nh-statRowSplit">
                  <div className="nh-stat">
                    <div className="nh-statTop">
                      <span className="nh-ic">⚡</span>
                      <strong>1–5 days</strong>
                    </div>
                    <div className="nh-statSub">Typical offer turnaround</div>
                  </div>

                  <div className="nh-stat">
                    <div className="nh-statTop">
                      <span className="nh-ic">🧾</span>
                      <strong>Less paperwork</strong>
                    </div>
                    <div className="nh-statSub">Trusted data rails</div>
                  </div>

                  <div className="nh-stat">
                    <div className="nh-statTop">
                      <span className="nh-ic">🔎</span>
                      <strong>Transparent</strong>
                    </div>
                    <div className="nh-statSub">Clear terms &amp; updates</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* QUICK STATS STRIP */}
        <section className="nh-strip">
          <div className="nh-wrap nh-stripInner">
            <div className="nh-stripGrid">
              {quickStats.map((s) => (
                <div className="nh-stripItem" key={s.label}>
                  <div className="nh-stripBig">{s.big}</div>
                  <div className="nh-stripLabel">{s.label}</div>
                </div>
              ))}
            </div>

            <div className="nh-stripCta">
              <div className="nh-stripKicker">And most importantly, it's</div>
              <div className="nh-stripTitle">Completely Free!</div>
              <button
                className="nh-btn primary"
                type="button"
                onClick={() => navigateTo("/auth/signin")}
              >
                Get Started <span className="nh-arrow">→</span>
              </button>
            </div>
          </div>
        </section>

        {/* REST OF INFO (after HERO) */}
        <section className="nh-afterHero" style={{ marginTop: "20px" }}>
          <div className="nh-wrap">
            <div className="nh-afterGrid">
              {/* LEFT: onboarding panel */}
              <div className="nh-panel nh-afterPanel">
                <div className="nh-panelHead">
                  <div
                    style={{
                      display: "flex",
                      alignItems: isMobile ? "flex-start" : "center",
                      gap: "20px",
                      flexDirection: isMobile ? "column" : "row",
                    }}
                  >
                    <div className="nh-inlineIntegration">
                      <img
                        src={singpassLogo}
                        alt="Singpass"
                        style={{
                          width: isMobile ? "25vw" : "7vw",
                          objectFit: "contain",
                          height: isMobile ? "25vw" : "7vw",
                        }}
                      />
                      <span className="nh-plus">+</span>
                      <img
                        src={corppasslogo}
                        alt="Singpass"
                        style={{
                          width: isMobile ? "25vw" : "7vw",
                          objectFit: "contain",
                          height: isMobile ? "25vw" : "7vw",
                        }}
                      />
                    </div>
                    <div>
                      <div className="nh-eyebrow">SMART ONBOARDING</div>
                      <div className="nh-panelTitle">Singpass + CorpPass</div>
                    </div>
                  </div>
                  <span className="nh-chip ok">Secure</span>
                </div>

                <div className="nh-steps">
                  <div className="nh-step">
                    <div className="nh-stepNum">1</div>
                    <div className="nh-stepTxt">
                      <div className="nh-stepTitle">Sign in with Singpass</div>
                      <div className="nh-stepDesc">
                        Verify identity instantly
                      </div>
                    </div>
                  </div>

                  <div className="nh-step">
                    <div className="nh-stepNum">2</div>
                    <div className="nh-stepTxt">
                      <div className="nh-stepTitle">Connect CorpPass</div>
                      <div className="nh-stepDesc">
                        Auto-fill company profile
                      </div>
                    </div>
                  </div>

                  <div className="nh-step">
                    <div className="nh-stepNum">3</div>
                    <div className="nh-stepTxt">
                      <div className="nh-stepTitle">Submit once</div>
                      <div className="nh-stepDesc">
                        Compare matching lender options
                      </div>
                    </div>
                  </div>
                </div>

                <div className="nh-panelFoot">
                  <img src={singpassLogo} alt="Singpass" />
                  <span>Encrypted, consent-based data sharing.</span>
                </div>
              </div>

              {/* RIGHT: benefits + optional highlight card */}
              <div className="nh-afterRight">
                <div className="nh-afterMiniGrid">
                  <div className="nh-mini nh-afterMini">
                    <div className="nh-miniTop">
                      <span className="nh-miniIc">✅</span>
                      <strong>Guided support</strong>
                    </div>
                    <p>We help you package submissions and match lenders.</p>
                  </div>

                  <div className="nh-mini nh-afterMini">
                    <div className="nh-miniTop">
                      <span className="nh-miniIc">🧠</span>
                      <strong>Smarter forms</strong>
                    </div>
                    <p>Cleaner inputs → fewer back-and-forth requests.</p>
                  </div>
                </div>

                {/* Optional: a premium “confidence” card that ties the flow together */}
                <div className="nh-afterHighlight">
                  <div className="nh-afterHighlightTop">
                    <span className="nh-tag violet">Clarity</span>
                    <span className="nh-afterHighlightKicker">
                      No messy paperwork
                    </span>
                  </div>

                  <div className="nh-afterHighlightTitle">
                    Track progress and requirements in one place.
                  </div>

                  <div className="nh-afterBullets">
                    <div className="nh-afterBullet">
                      <span className="nh-afterDot" />
                      Clear checklist of required documents
                    </div>
                    <div className="nh-afterBullet">
                      <span className="nh-afterDot" />
                      Updates as lenders review your submission
                    </div>
                    <div className="nh-afterBullet">
                      <span className="nh-afterDot" />
                      Compare offers side-by-side
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FEATURED */}
        <section className="nh-section">
          <div className="nh-wrap nh-sectionHead">
            <h2>Featured on</h2>
            <p>Recognized by partners and trusted platforms.</p>
          </div>

          <div className="nh-wrap">
            <div className="nh-marquee" style={{ height: "200px" }}>
              <div className="nh-marqueeTrack">
                {marqueeLogos.map((logo, idx) => (
                  <div className="nh-logoTile" key={`${idx}-${logo}`}>
                    <div
                      className="nh-logoFrame"
                      aria-hidden="true"
                      style={{
                        height: "150px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        src={logo}
                        alt={`featured-${idx % featuredLogos.length}`}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* INTEGRATION */}
        <section id="integration" className="nh-section">
          <div className="nh-wrap nh-sectionHead">
            <h2>Seamless Singpass + CorpPass integration</h2>
            <p>
              Secure onboarding through trusted national identity rails means
              less manual paperwork and safer verification.
            </p>
          </div>

          <div className="nh-wrap nh-cardGrid3">
            <article className="nh-card">
              <div className="nh-cardTop">
                <span className="nh-tag blue">Secure</span>
              </div>
              <h3>Consent-based verification</h3>
              <p>
                Borrowers stay in control. Data is shared only with explicit
                consent and used to streamline onboarding.
              </p>
            </article>

            <article className="nh-card nh-cardSoftGlow">
              <div className="nh-cardTop">
                <span className="nh-tag violet">Fast</span>
              </div>
              <h3>Less form filling</h3>
              <p>
                Reduce repeated fields and mismatches across documents with a
                cleaner, guided flow.
              </p>

              <div className="nh-inlineIntegration">
                <img
                  src={singpassLogo}
                  alt="Singpass"
                  style={{
                    width: isMobile ? "30vw" : "7vw",
                    objectFit: "contain",
                    height: isMobile ? "30vw" : "7vw",
                  }}
                />
                <span className="nh-plus">+</span>
                <img
                  src={corppasslogo}
                  alt="Singpass"
                  style={{
                    width: isMobile ? "30vw" : "7vw",
                    objectFit: "contain",
                    height: isMobile ? "30vw" : "7vw",
                  }}
                />
              </div>
            </article>

            <article className="nh-card">
              <div className="nh-cardTop">
                <span className="nh-tag gray">Reliable</span>
              </div>
              <h3>Cleaner submissions</h3>
              <p>
                Better inputs mean fewer follow-ups, faster reviews, and clearer
                offer expectations.
              </p>
            </article>
          </div>
        </section>

        {/* WHY US */}
        <section id="why-us" className="nh-section">
          <div className="nh-wrap nh-sectionHead">
            <h2>Why businesses and individuals choose SmartLend</h2>
            <p>Designed to feel premium, but stay simple and predictable.</p>
          </div>

          <div className="nh-wrap nh-cardGrid3">
            <article className="nh-card hover">
              <div className="nh-cardTop split">
                <span className="nh-ic">🏦</span>
                <span className="nh-tag blue">Choice</span>
              </div>
              <h3>Multiple lender options</h3>
              <p>Receive and compare offers in one place.</p>
              <div className="nh-meta">Compare • Decide • Proceed</div>
            </article>

            <article className="nh-card hover">
              <div className="nh-cardTop split">
                <span className="nh-ic">🧑‍💼</span>
                <span className="nh-tag violet">Guided</span>
              </div>
              <h3>Guided support</h3>
              <p>We support you across submission and lender matching.</p>
              <div className="nh-meta">Advisor review • Packaging</div>
            </article>

            <article className="nh-card hover">
              <div className="nh-cardTop split">
                <span className="nh-ic">🧾</span>
                <span className="nh-tag gray">Clear</span>
              </div>
              <h3>Built for transparency</h3>
              <p>Understand repayment, rates and timelines upfront.</p>
              <div className="nh-meta">No surprises • Clear updates</div>
            </article>
          </div>
        </section>

        {/* CONCIERGE BANNER */}
        <section className="nh-concierge">
          <div className="nh-wrap nh-conciergeInner">
            <div className="nh-conciergeMedia">
              <img
                src={asianWomanHappy}
                alt="Concierge support"
                className="nh-conciergeImg"
              />
            </div>

            <div className="nh-conciergeLeft">
              <h2 className="nh-conciergeH2">
                Upgrade to <span className="nh-conciergeAccent">Concierge</span>
                :
              </h2>

              <p className="nh-conciergeSub">Your Fast-Track to Funding</p>
              <p className="nh-conciergeDesc">
                Enjoy one-on-one RM support, pre-approval checks, and direct
                lender negotiations.
              </p>

              <div className="nh-conciergeBtns">
                <button
                  className="nh-btn ghost"
                  type="button"
                  onClick={() => {
                    setConciergeModalIsOpen(true);
                  }}
                >
                  Learn more
                </button>
                <button
                  className="nh-btn primary"
                  type="button"
                  onClick={() => {
                    history.push("/auth/signin");
                    window.scrollTo(0, 0);
                  }}
                >
                  Get Concierge Access
                </button>
              </div>

              <div className="nh-conciergeCard">
                <div className="nh-conciergeGrid">
                  {conciergeBenefits.map((b) => (
                    <div className="nh-conciergeBenefit" key={b.title}>
                      <div className="nh-conciergeIcon">{b.icon}</div>
                      <div>
                        <div className="nh-conciergeTitle">{b.title}</div>
                        <div className="nh-conciergeText">{b.desc}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* DARK CONTRAST PROMISE */}
        <section className="nh-section nh-dark">
          <div className="nh-wrap nh-darkInner">
            <div className="nh-darkHead">
              <div>
                <div className="nh-darkEyebrow">OUR PROMISE</div>
                <h2>Speed — with real advisory</h2>
                <p>
                  We don’t just pass your form around. We help you understand
                  the trade-offs and choose a practical route.
                </p>
              </div>

              <div className="nh-darkChips">
                <span className="nh-dchip">🧭 Clear direction</span>
                <span className="nh-dchip">🛠️ Practical routes</span>
                <span className="nh-dchip">📣 Transparent updates</span>
              </div>
            </div>

            <div className="nh-darkGrid">
              <article className="nh-dcard">
                <div className="nh-dcardTop">
                  <span className="nh-dic">⚡</span>
                  <span className="nh-dtag">Fast</span>
                </div>
                <h3>Fast, guided financing journey</h3>
                <p>
                  Quick steps, clear checkpoints, and updates so you always know
                  what’s happening.
                </p>
              </article>

              <article className="nh-dcard">
                <div className="nh-dcardTop">
                  <span className="nh-dic">🧱</span>
                  <span className="nh-dtag">Resilient</span>
                </div>
                <h3>Support for challenging profiles</h3>
                <p>
                  Even if financials aren’t perfect, we explore structures and
                  realistic options.
                </p>
              </article>

              <article className="nh-dcard">
                <div className="nh-dcardTop">
                  <span className="nh-dic">🧷</span>
                  <span className="nh-dtag">No dead-ends</span>
                </div>
                <h3>No business left hanging</h3>
                <p>
                  If one option doesn’t fit, we guide you to the next best route
                  with clarity.
                </p>
              </article>
            </div>

            <div className="nh-darkFooterChips">
              <span className="nh-dchip">📦 Better packaging</span>
              <span className="nh-dchip">📌 Clear requirements</span>
              <span className="nh-dchip">🤝 Human support</span>
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="nh-section">
          <div className="nh-wrap nh-sectionHead">
            <h2>FAQ</h2>
            <p>Quick answers to common questions.</p>
          </div>

          <div className="nh-wrap nh-faqCats" aria-label="FAQ categories">
            {faqCategories.map((category) => (
              <button
                key={category.key}
                type="button"
                className={`nh-faqCat ${
                  faqCat === category.key ? "active" : ""
                }`}
                onClick={() => {
                  setFaqCat(category.key);
                  setOpenFaq(0);
                }}
              >
                {category.label}
              </button>
            ))}
          </div>

          <div className="nh-wrap nh-faq">
            {filteredFaqs.map((item, idx) => {
              const open = openFaq === idx;
              return (
                <div
                  className={`nh-faqItem ${open ? "open" : ""}`}
                  key={item.q}
                >
                  <button
                    className="nh-faqBtn"
                    type="button"
                    onClick={() => setOpenFaq(open ? -1 : idx)}
                    aria-expanded={open}
                  >
                    <span>{item.q}</span>
                    <span className="nh-faqIcon">{open ? "–" : "+"}</span>
                  </button>
                  <div className="nh-faqBody">
                    {typeof item.a === "string" ? <p>{item.a}</p> : item.a}
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        {/* REVIEWS */}
        <section className="nh-section">
          <div className="nh-wrap nh-sectionHead">
            <h2>Google reviews</h2>
            <p>Rated by business owners across Singapore.</p>
          </div>

          <div className="nh-wrap nh-reviewHead">
            <img src={googleLogo} alt="Google" />
            <span>Trusted feedback from real borrowers</span>
            <span className="nh-stars">★★★★★</span>
          </div>

          <div className="nh-wrap nh-cardGrid3">
            {reviews.map((r) => (
              <article className="nh-card hover" key={r.name}>
                <div className="nh-reviewTop">
                  <div className="nh-avatar">{r.name?.[0] || "S"}</div>
                  <div>
                    <div className="nh-reviewName">{r.name}</div>
                    <div className="nh-reviewStars">★★★★★</div>
                  </div>
                </div>
                <p className="nh-reviewText">{r.text}</p>
              </article>
            ))}
          </div>
        </section>

        {/* TRUSTED CLIENTS */}
        <section className="nh-trusted">
          <div className="nh-wrap nh-trustedHead">
            <h2>
              Our trusted <span className="nh-trustedAccent">Clients</span>
            </h2>
            <p>
              Don’t just take our word for it — hear from business owners like
              you.
            </p>
          </div>

          <div className="nh-wrap nh-trustedGrid">
            {clientTestimonials.map((t) => (
              <article className="nh-tcard" key={`${t.name}-${t.role}`}>
                <div className="nh-tcardTop">
                  <div className="nh-tavatar">{t.name?.[0] || "S"}</div>
                  <div className="nh-tmeta">
                    <div className="nh-tname">{t.name}</div>
                    <div className="nh-trole">{t.role}</div>
                  </div>
                  <div className="nh-tstars">{"★".repeat(t.stars)}</div>
                </div>
                <p className="nh-ttext">{t.text}</p>
              </article>
            ))}
          </div>
        </section>

        {/* CTA + Newsletter (tight + aligned) */}
        <section className="nh-section">
          <div className="nh-wrap nh-ctaBar">
            <div>
              <h2>Ready to apply with confidence?</h2>
              <p>
                Start with a guided flow — we’ll help you submit cleanly and
                compare options faster.
              </p>
            </div>
            <div className="nh-ctaBtns">
              <button
                className="nh-btn primary"
                type="button"
                onClick={() => navigateTo("/auth/signin")}
              >
                Get started <span className="nh-arrow">→</span>
              </button>
              <button
                className="nh-btn ghost"
                type="button"
                onClick={() => navigateTo("/contactus")}
              >
                Contact support
              </button>
            </div>
          </div>

          <div className="nh-wrap nh-newsBar">
            <div>
              <h2>Newsletter</h2>
              <p>Weekly financing insights and borrower tips — no spam.</p>
            </div>

            <form className="nh-newsForm" onSubmit={handleEmailSubscription}>
              <input
                type="email"
                placeholder="Enter your email"
                value={emailSubscription}
                onChange={(e) => setEmailSubscription(e.target.value)}
              />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </section>
      </main>

      <NewHomepageFooter />
    </div>
  );
};

export default NewHomepage;
